/**
 * @ngdoc directive
 * @name WebCoreModule.directive:wcChart
 * @restrict E
 * @scope
 * @param {array} data The array of data to render a chart from
 * @param {string} type The type of chart to render. Can be Line, Bar or Pie
 * @param {object} options An object with configuration options for the chart
 * @param {number} height the height of the canvas
 * @description
 * The wcChart directive utilizes the Chart.js library to provide charting capabilities via an Angular directive.
 * The directive provides customization for various chart types via the passed in attributes on the tag.
 */

angular.module('WebCoreModule')
    .directive('wcChart', ['Chart',  function (Chart) {
        return {
            restrict: 'E',
            scope: {
                data: '&data',
                options: '&options',
                type: '@',
                height: "="
            },
            replace: true,
            template: '<canvas></canvas>',
            link: function ($scope, $element) { // jshint ignore:line
                // jshint unused:true
                var chartObj;
                $scope.data = $scope.data();
                $scope.options = $scope.options();

                this.defaultOptions = {
                    responsive: true,
                    maintainAspectRatio: false
                };

                $.extend($scope.options, this.defaultOptions );

                this.height = $scope.height || 300;

                $element.wrap("<div style='height:" + this.height + "px ' class='chart-container'></div>");

                var cvs = $element[0];

                // Watch for Changes to Data Set & options


                $scope.$watch('data', angular.bind(this, function(value) {
                    if(value) {
                        this.destroyChart();

                        chartObj = new Chart(cvs, {
                            type: $scope.type,
                            data: $scope.data,
                            options: $scope.options
                        });
                        chartObj.resize();
                    }
                }, true));

                $scope.$on('$destroy', angular.bind(this, function () {
                    this.destroyChart();
                }));

                this.destroyChart = function () {
                    if (chartObj) {
                        chartObj.destroy();
                    }
                };


                /* Update chart when changes occure on data */
                $scope.$on('update', angular.bind(this, function () {
                    chartObj.update();
                }));

            }
        };
    }]);